<template>
  <!-- 질문28 -->
  <v-layout flex-fill column class="survey-type-06">
    <div class="subheader">아래 그림을 보고 질문에 응답해 주세요.</div>
    <!-- TODO 임시 텍스트 하드 코딩 -->
    <div class="question">
      사진 속 사람은<br> '누구'이며, 어떤 '상황'이고, 어떤 '기분'을<br> 느끼고 있을까요?
    </div>
    <!--      <div class="question" v-html="question"></div>-->
    <div class="answer" style="height: 35vh; max-height: 100vw; overflow: hidden">
      <v-img aspect-ratio="4/3" height="100%" :src="getImage(imgURL)" contain/>
    </div>
    <div class="answer">
        <Textarea
            auto-grow
            rows="1"
            :no-resize="false"
            :value="value"
            :counter="500"
            :placeholder="'최대한 자세히 작성해보세요.'"
            height="auto"
            @input="inputChanged"
        />
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import { mixinAuth } from '@/mixins'
import Textarea from '@/components/forms/Textarea'

export default {
  components: {
    Textarea
  },
  mixins: [mixinAuth],
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    value: '',
    //imgURL: 'photo.png',
    imgURL: 'dms_travel_40_img.png'
  }),
  created() {
    this.getStepLoadData();
  },
  methods: {
    inputChanged(input) {
      this.value = input;
      this.$emit('emotionSelected', input);
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 06 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            this.value = res.data.reply;
            this.inputChanged(res.data.reply);
          } else {
            console.log(res.msg)
            this.value = '';
          }
        })
        .catch(error => {
          console.error(error)
          this.value = '';
        })
        .finally(() => {
        })
    },
  }

}
</script>
